<template>
  <div id="app" class="pnr-report-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>PNR Bazlı Rapor</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>

          <v-container fluid class="page-container">
            <v-form ref="formPnrBazliRapor" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat class="filter-card">
                    <v-card-text>
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm6 md2 pt-2>
                          <v-select
                            :label="$t('Date-Type')"
                            item-value="value"
                            item-text="text"
                            :items="tarihTipItems"
                            v-model="prm.TarihTip"
                            solo
                            flat
                            hide-details
                          ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pt-2>
                          <tarihcomp
                            :etiket="$t('Starting-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            v-model="date"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pt-2>
                          <tarihcomp
                            :etiket="$t('Finishing-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            v-model="date2"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pt-2>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              block
                              round
                              :color="cariDetayli ? 'deep-purple' : 'blue-grey lighten-5'"
                              :dark="cariDetayli"
                              :class="cariDetayli ? 'detail-toggle-active' : 'detail-toggle'"
                              @click="toggleCariDetayli()"
                            >
                              <v-icon left>
                                {{ cariDetayli ? 'expand_less' : 'group_work' }}
                              </v-icon>
                              {{ cariDetayli ? 'Cari Detay Açık' : 'Cari Detaylandır' }}
                            </v-btn>
                            <span>Çoklu cari olan PNR'ları cari kırılımıyla gösterir.</span>
                          </v-tooltip>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pt-2>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              block
                              round
                              :color="parkurDetayli ? 'teal' : 'blue-grey lighten-5'"
                              :dark="parkurDetayli"
                              :class="parkurDetayli ? 'route-toggle-active' : 'detail-toggle'"
                              @click="toggleParkurDetayli()"
                            >
                              <v-icon left>
                                {{ parkurDetayli ? 'timeline' : 'alt_route' }}
                              </v-icon>
                              {{ parkurDetayli ? 'Parkur Detay Açık' : 'Parkurları Detaylandır' }}
                            </v-btn>
                            <span>Parkurlar özet rota yerine Parkur 1-5 olarak açılır.</span>
                          </v-tooltip>
                        </v-flex>

                        <v-flex xs12 sm12 md2 pt-2>
                          <div class="filter-actions">
                            <v-btn
                              v-if="load1"
                              color="info"
                              @click="getList()"
                              fab
                              small
                              dark
                            >
                              <v-icon>search</v-icon>
                            </v-btn>

                            <div v-if="progress" class="progress-wrap">
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                                size="28"
                              ></v-progress-circular>
                            </div>

                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                small
                                @click="filtrele()"
                                color="info"
                                fab
                                dark
                              >
                                <v-icon>filter_list</v-icon>
                              </v-btn>
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap class="summary-cards-row">
                        <v-flex xs12 sm6 md3>
                          <div class="summary-card summary-pnr">
                            <div class="summary-card-title">Toplam PNR</div>
                            <div class="summary-card-value">{{ toplamPnr }}</div>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm6 md3>
                          <div class="summary-card summary-passenger">
                            <div class="summary-card-title">Toplam Yolcu</div>
                            <div class="summary-card-value">{{ toplamYolcu }}</div>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm6 md2>
                          <div class="summary-card summary-sales">
                            <div class="summary-card-title">Toplam Satış</div>
                            <div class="summary-card-value">
                              {{ formatMoneyDisplay(toplamSatis) }}
                            </div>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm6 md2>
                          <div class="summary-card summary-buying">
                            <div class="summary-card-title">Toplam Alış</div>
                            <div class="summary-card-value">
                              {{ formatMoneyDisplay(toplamAlis) }}
                            </div>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm6 md2>
                          <div class="summary-card summary-profit">
                            <div class="summary-card-title">Toplam Kar</div>
                            <div class="summary-card-value">
                              {{ formatMoneyDisplay(toplamKar) }}
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="cariDetayli || parkurDetayli" row wrap>
                        <v-flex xs12>
                          <div class="detail-info-box">
                            <v-icon small class="mr-2">info</v-icon>
                            <span v-if="cariDetayli && parkurDetayli">
                              Cari detay ve parkur detay açık. Çoklu cariler alt satırda, parkurlar ise Parkur 1-5 kolonlarında gösterilir.
                            </span>
                            <span v-else-if="cariDetayli">
                              Cari detay açık. Çoklu cari tespit edilen PNR'larda ana toplam satırının altında cari kırılımları gösterilir.
                            </span>
                            <span v-else>
                              Parkur detay açık. Özet rota kolonu yerine Parkur 1-5 kolonları gösterilir.
                            </span>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-1>
                  <ReportTable
                    :headers="displayHeaders"
                    :items="items"
                    :loading="progress"
                    :has-searched="hasSearched"
                    storage-key="pnr_bazli_rapor_table_v3"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :rows-per-page-items="[20, 50, 100]"
                    :excel-summary-config="activeExcelSummaryConfig"
                    class="report-table-host"
                  >
                    <template slot="cell" slot-scope="slotProps">
                      <div
                        class="cell-area"
                        :class="slotProps.item && slotProps.item.DetaySatiri ? 'detail-row-cell' : ''"
                      >
                        {{ slotProps.value }}
                      </div>
                    </template>
                  </ReportTable>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <div class="bottom-summary-bar">
                    <div class="bottom-summary-item">
                      <span class="bottom-summary-label">Toplam PNR:</span>
                      <strong class="bottom-summary-value">{{ toplamPnr }}</strong>
                    </div>

                    <div class="bottom-summary-item">
                      <span class="bottom-summary-label">Toplam Yolcu:</span>
                      <strong class="bottom-summary-value">{{ toplamYolcu }}</strong>
                    </div>

                    <div class="bottom-summary-item">
                      <span class="bottom-summary-label">Toplam Satış:</span>
                      <strong class="bottom-summary-value">
                        {{ formatMoneyDisplay(toplamSatis) }}
                      </strong>
                    </div>

                    <div class="bottom-summary-item">
                      <span class="bottom-summary-label">Toplam Alış:</span>
                      <strong class="bottom-summary-value">
                        {{ formatMoneyDisplay(toplamAlis) }}
                      </strong>
                    </div>

                    <div class="bottom-summary-item">
                      <span class="bottom-summary-label">Toplam Kar:</span>
                      <strong class="bottom-summary-value">
                        {{ formatMoneyDisplay(toplamKar) }}
                      </strong>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="760px">
            <v-card flat color="grey lighten-5">
              <v-card-title>
                <span class="headline">Filtre Seçimi</span>
                <v-spacer></v-spacer>
                <v-btn icon flat small @click="dialogfiltre = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md6 pa-2>
                    <cariaracomp
                      :etiket="$t('Currentcode_label')"
                      v-model="prm.CariKod"
                    ></cariaracomp>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.BaslangicBiletNo"
                      mask="##########"
                      :label="$t('Starting-Ticket-No')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.BitisBiletNo"
                      mask="##########"
                      :label="$t('Ending-Ticket-No')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.YolcuAdi"
                      :label="$t('Name-of-Passenger')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.FaturaNo"
                      :label="$t('Invoice-No')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <kesenkisi
                      :etiket="$t('Ticket-Agent')"
                      v-model="prm.KesenKisi"
                    ></kesenkisi>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.SiparisNo"
                      :label="$t('Order-No')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4 pa-2>
                    <v-select
                      :items="hattipiitems"
                      item-text="text"
                      item-value="value"
                      v-model="prm.HatTipi"
                      :label="$t('Line-Type')"
                      hide-details
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4 pa-2>
                    <v-select
                      :items="satistipiitems"
                      item-text="text"
                      item-value="value"
                      v-model="prm.SatisTipi"
                      :label="$t('Sales-Type')"
                      hide-details
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4 pa-2>
                    <v-select
                      :items="odemetipiitems"
                      item-text="text"
                      item-value="value"
                      v-model="prm.OdemeTipi"
                      :label="$t('Payment-Type')"
                      hide-details
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.BiletAciklama"
                      :label="$t('Ticket-Description')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 pa-2>
                    <v-text-field
                      v-model="prm.DepartmanKodu"
                      :label="$t('Department-Code')"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4 pa-2>
                    <v-checkbox
                      v-model="tumsirketler"
                      :label="$t('All-Companies')"
                      hide-details
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm6 md4 pa-2>
                    <v-checkbox
                      v-model="prm.IadeSatisSifirla"
                      :label="$t('Reset-the-sales-price-of-refunded-tickets')"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="filtreiptal()">
                  {{ $t("cancel_button") }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="filtrekayit()">
                  {{ $t('Apply-Filters') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import kesenkisi from "@/components/app/customcomp/kesenkisi";
import tool from "../../coper/tools";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function textHeader(text, value, minWidth) {
  return {
    text: text,
    value: value,
    type: "text",
    align: "left",
    visible: true,
    sortable: true,
    minWidth: minWidth || "140px"
  };
}

function moneyHeader(text, value, minWidth) {
  return {
    text: text,
    value: value,
    type: "money",
    align: "right",
    visible: true,
    sortable: true,
    minWidth: minWidth || "140px"
  };
}

function numberHeader(text, value, minWidth) {
  return {
    text: text,
    value: value,
    type: "number",
    align: "right",
    visible: true,
    sortable: true,
    minWidth: minWidth || "120px"
  };
}

function createHeaders(parkurDetayli) {
  var headers = [
    textHeader("PNR", "PnrNo", "120px"),
    textHeader("Bilet No", "BiletNolari", "160px"),
    textHeader("Cari Kodu", "CariKod", "140px"),
    textHeader("Cari Adı", "CariAdi", "220px"),
    textHeader("Cari Hesap", "CariHesap", "260px"),
    textHeader("Cari Ünvanı 1", "CariUnvani1", "220px"),
    textHeader("Cari Ünvanı 2", "CariUnvani2", "220px"),
    textHeader("Havayolu", "HavayoluKodlari", "130px")
  ];

  if (parkurDetayli) {
    headers.push(textHeader("Parkur 1", "Parkur1", "110px"));
    headers.push(textHeader("Parkur 2", "Parkur2", "110px"));
    headers.push(textHeader("Parkur 3", "Parkur3", "110px"));
    headers.push(textHeader("Parkur 4", "Parkur4", "110px"));
    headers.push(textHeader("Parkur 5", "Parkur5", "110px"));
  } else {
    headers.push(textHeader("Parkurlar", "Parkurlar", "260px"));
  }

  headers.push(textHeader("Classlar", "Classlar", "120px"));
  headers.push(textHeader("Acenta", "Acenta", "180px"));
  headers.push(textHeader("Acenta CH Kod", "AcentaCHKod", "180px"));
  headers.push(moneyHeader("Toplam Alış", "ToplamAlis", "150px"));
  headers.push(moneyHeader("Toplam Satış", "ToplamSatis", "150px"));
  headers.push(moneyHeader("Toplam Kar", "ToplamKar", "140px"));
  headers.push(numberHeader("Toplam Yolcu", "ToplamYolcu", "140px"));

  return headers;
}

function emptyPrm() {
  return {
    SirketKodu: null,
    BaslangicTarih: null,
    BitisTarih: null,
    TarihTip: 0,

    CariKod: null,
    AltHesapGoster: false,
    IadeCariKod: false,

    Havayollari: [],
    BaslangicBiletNo: null,
    BitisBiletNo: null,
    Referanslar: [],
    Masraflar: [],
    Parkurlar: [],
    Classlar: [],

    YolcuAdi: null,
    BiletAciklama: null,

    HatTipi: 0,
    SatisTipi: 0,
    OdemeTipi: 0,

    FaturaNo: null,
    KesenKisi: null,
    HesapGruplari: [],
    Dovizler: [],

    AnaHesap: null,
    AcentaKodu: null,
    AnalizKodu: null,
    DepartmanKodu: null,
    PinKodu: null,
    ClassTip: null,

    BiletYon: 0,
    CrsTip: null,
    Efaturali: false,

    PnrNo: null,
    SiparisNo: null,

    SadeceTevkifatli: false,
    DigerServisKontrol: false,
    DegiskenKontrol: false,
    IadeSatisSifirla: false,

    ProfilSablonID: null,
    CariDetayli: false
  };
}

export default {
  name: "PnrBazliRapor",
  components: {
    tarihcomp,
    yetkidialog,
    loadingcomp,
    cariaracomp,
    kesenkisi,
    ReportTable
  },
  data() {
    return {
      items: [],
      hasSearched: false,
      loadingvmodel: false,
      progress: false,
      load1: true,
      valid: true,

      date: null,
      date2: null,
      prm: emptyPrm(),

      cariDetayli: false,
      parkurDetayli: false,
      tumsirketler: false,
      filtrevarmi: false,
      dialogfiltre: false,

      sayfayetki: {
        Screen: true,
        Update: true,
        Save: true,
        Delete: true,
        Status: true,
        Message: null,
        islem: 0
      },

      excelSummaryConfig: {
        label: "Genel Toplam",
        fields: [
          { key: "ToplamAlis", type: "money" },
          { key: "ToplamSatis", type: "money" },
          { key: "ToplamKar", type: "money" },
          { key: "ToplamYolcu", type: "number" }
        ]
      },

      emptyExcelSummaryConfig: {
        label: "",
        fields: []
      },

      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: ""
    };
  },
  computed: {
    displayHeaders() {
      return createHeaders(this.parkurDetayli);
    },
    dateRules() {
      return [(v) => !!v || this.$t("Please-select-a-date")];
    },
    tarihTipItems() {
      return [
        { text: this.$t("Sales-Date"), value: 0 },
        { text: this.$t("Flight-Date"), value: 1 },
        { text: this.$t("Invoice-Date"), value: 2 },
        { text: this.$t("Refund-Invoice-Date"), value: 3 }
      ];
    },
    hattipiitems() {
      return [
        { text: this.$t("All"), value: 0 },
        { text: this.$t("Domestic-Line"), value: 1 },
        { text: this.$t("International-Line"), value: 2 },
        { text: "BSP", value: 3 }
      ];
    },
    satistipiitems() {
      return [
        { text: this.$t("All"), value: 0 },
        { text: this.$t("Sales"), value: 1 },
        { text: this.$t("Refund"), value: 2 }
      ];
    },
    odemetipiitems() {
      return [
        { text: this.$t("All"), value: 0 },
        { text: this.$t("With-Credit"), value: 1 },
        { text: this.$t("Cash"), value: 2 },
        { text: this.$t("R-Card"), value: 3 },
        { text: this.$t("F-Card"), value: 4 },
        { text: this.$t("C-Card"), value: 5 }
      ];
    },
    summaryItems() {
      if (!Array.isArray(this.items)) {
        return [];
      }

      return this.items.filter((item) => {
        return item.DetaySatiri !== true && item.SatirTipi !== "CARI";
      });
    },
    toplamPnr() {
      return this.summaryItems.length;
    },
    toplamYolcu() {
      return this.sumFieldFromSummary("ToplamYolcu");
    },
    toplamSatis() {
      return this.sumFieldFromSummary("ToplamSatis");
    },
    toplamAlis() {
      return this.sumFieldFromSummary("ToplamAlis");
    },
    toplamKar() {
      return this.sumFieldFromSummary("ToplamKar");
    },
    activeExcelSummaryConfig() {
      if (this.cariDetayli) {
        return this.emptyExcelSummaryConfig;
      }

      return this.excelSummaryConfig;
    }
  },
  mounted() {
    this.setDefaultDates();

    this.sayfayetki = {
      Screen: true,
      Update: true,
      Save: true,
      Delete: true,
      Status: true,
      Message: null,
      islem: 0
    };
  },
  methods: {
    setDefaultDates() {
      var today = new Date();
      var oneYearAgo = new Date();

      oneYearAgo.setFullYear(today.getFullYear() - 1);

      this.date = this.formatDateForInput(oneYearAgo);
      this.date2 = this.formatDateForInput(today);
    },
    formatDateForInput(dateValue) {
      var year = dateValue.getFullYear();
      var month = ("0" + (dateValue.getMonth() + 1)).slice(-2);
      var day = ("0" + dateValue.getDate()).slice(-2);

      return year + "-" + month + "-" + day;
    },
    toggleCariDetayli() {
      this.cariDetayli = !this.cariDetayli;
      this.prm.CariDetayli = this.cariDetayli;

      if (this.hasSearched) {
        this.getList();
      }
    },
    toggleParkurDetayli() {
      this.parkurDetayli = !this.parkurDetayli;
    },
    filtrele() {
      this.dialogfiltre = true;
    },
    filtrekayit() {
      this.filtrevarmi = true;
      this.dialogfiltre = false;
      this.getList();
    },
    filtreiptal() {
      this.filtrevarmi = false;
      this.dialogfiltre = false;

      var tarihTip = this.prm.TarihTip;

      this.prm = emptyPrm();
      this.prm.TarihTip = tarihTip;
      this.prm.CariDetayli = this.cariDetayli;

      this.tumsirketler = false;
    },
    validateDateRange() {
      if (!this.$refs.formPnrBazliRapor.validate()) {
        return false;
      }

      var bastarih = new Date(this.date);
      var bittarih = new Date(this.date2);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      return false;
    },
    createParams() {
      var credentialsRaw = window.localStorage.getItem("credentials");
      var credentials = {};

      if (credentialsRaw) {
        try {
          credentials = JSON.parse(credentialsRaw);
        } catch (e) {
          credentials = {};
        }
      }

      this.prm.BaslangicTarih = this.date;
      this.prm.BitisTarih = this.date2;
      this.prm.PnrNo = null;
      this.prm.CariDetayli = this.cariDetayli;

      if (this.tumsirketler === true) {
        this.prm.SirketKodu = 0;
      } else {
        this.prm.SirketKodu = credentials.SirketKodu;
      }

      return {
        prm: this.prm
      };
    },
    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.hasSearched = true;
      this.progress = true;
      this.load1 = false;

      var params = this.createParams();

      tool.api_post(this, "TicketReport/GetPnrBazliRapor", params).then(
        (response) => {
          var body = response.body || response.data || [];

          if (Array.isArray(body)) {
            this.items = body;
          } else if (body.data && Array.isArray(body.data)) {
            this.items = body.data;
          } else if (body.Data && Array.isArray(body.Data)) {
            this.items = body.Data;
          } else {
            this.items = [];
          }

          this.progress = false;
          this.load1 = true;
        },
        () => {
          this.items = [];
          this.progress = false;
          this.load1 = true;
          this.text1 = "PNR bazlı rapor getirilemedi.";
          this.snackbar = true;
        }
      );
    },
    getRawNumberValue(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }

      if (typeof value === "number") {
        return isNaN(value) ? 0 : value;
      }

      var normalized = String(value)
        .replace(/\s/g, "")
        .replace(/\./g, "")
        .replace(/,/g, ".");

      var parsed = parseFloat(normalized);
      return isNaN(parsed) ? 0 : parsed;
    },
    sumFieldFromSummary(fieldName) {
      if (!Array.isArray(this.summaryItems) || !this.summaryItems.length) {
        return 0;
      }

      return this.summaryItems.reduce((total, item) => {
        return total + this.getRawNumberValue(item[fieldName]);
      }, 0);
    },
    formatMoneyDisplay(value) {
      return helpers.moneyformat(value || 0);
    }
  }
};
</script>

<style scoped>
.pnr-report-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.filter-card {
  background: #ffffff;
  border-radius: 6px;
}

.filter-actions {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.progress-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.detail-toggle {
  color: #37474f !important;
  font-weight: 600;
  box-shadow: none;
  border: 1px solid #d9e2ec;
}

.detail-toggle-active {
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(103, 58, 183, 0.25);
}

.route-toggle-active {
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(0, 150, 136, 0.25);
}

.detail-info-box {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f4efff;
  color: #512da8;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.summary-cards-row {
  margin-top: 18px;
  margin-bottom: 4px;
}

.summary-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  min-height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.summary-card-title {
  font-size: 13px;
  color: #607d8b;
  margin-bottom: 8px;
  font-weight: 600;
}

.summary-card-value {
  font-size: 22px;
  font-weight: 700;
  color: #263238;
  line-height: 1.2;
  word-break: break-word;
}

.summary-pnr {
  border-top: 4px solid #607d8b;
}

.summary-passenger {
  border-top: 4px solid #9c27b0;
}

.summary-sales {
  border-top: 4px solid #2196f3;
}

.summary-buying {
  border-top: 4px solid #ff9800;
}

.summary-profit {
  border-top: 4px solid #4caf50;
}

.report-table-host {
  width: 100%;
}

.bottom-summary-bar {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  padding: 14px 8px 2px 8px;
}

.bottom-summary-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bottom-summary-label {
  font-size: 14px;
  color: #607d8b;
  font-weight: 600;
}

.bottom-summary-value {
  font-size: 16px;
  color: #263238;
}

.cell-area {
  display: block;
  width: 100%;
  min-height: 24px;
  white-space: pre-line;
}

.detail-row-cell {
  padding-left: 18px;
  font-weight: 600;
  color: #5e35b1;
}

@media (max-width: 960px) {
  .filter-actions {
    justify-content: flex-start;
  }

  .summary-cards-row {
    margin-top: 14px;
  }

  .bottom-summary-bar {
    justify-content: flex-start;
    gap: 14px;
  }

  .bottom-summary-item {
    width: 100%;
  }
}
</style>